<div class="flex justify-center items-center bg-gray-100 h-full">
  <div
    class="h-full w-full bg-white shadow-lg rounded-lg flex gap-8 pl-12 pt-12 pr-12 pb-4"
    [ngClass]="windowSize < 1024 ? 'justify-center' : 'justify-between'"
  >
    <div
      class="flex-col w-10/20 h-full"
      [ngClass]="windowSize < 1024 ? 'p-2' : 'p-16'"
    >
      <div
        class="flex items-center gap-x-4 w-fit cursor-pointer"
        (click)="goBackToLoginPage()"
      >
        <div
          class="flex rounded-3xl items-center justify-center bg-neutral-50 p-2"
        >
          <mat-icon fontSet="material-icons-outlined">chevron_left</mat-icon>
        </div>
        <span class="back-to-login-button text-neutral-400">Voltar</span>
      </div>
      <img
        src="assets/images/blue-logo-image.svg"
        alt="Logo"
        class="h-55 w-85"
      />
      <h2 class="text-2xl font-bold mb-2">Recuperação de senha!</h2>
      <p class="text-gray-600 mb-8">
        Para recuperar sua senha, insira seu e-mail cadastrado e siga as
        instruções enviadas.
      </p>

      <form class="space-y-4">
        <div class="space-y-2">
          <p>E-mail</p>
          <div>
            <mat-form-field appearance="outline" class="w-full form-field">
              <input
                matInput
                type="email"
                placeholder="contato@mail.com.br"
                [formControl]="recoverPasswordControl"
              />
            </mat-form-field>
            @if (recoverPasswordControl.touched &&
            recoverPasswordControl.invalid &&
            recoverPasswordControl.errors?.['email']) {
            <mat-error>Informe um e-mail válido</mat-error>
            } @if (recoverPasswordControl.touched &&
            recoverPasswordControl.invalid &&
            recoverPasswordControl.errors?.['required']) {
            <mat-error>E-mail é obrigatório</mat-error>
            } @if (recoverPasswordControl.touched &&
            recoverPasswordControl.invalid &&
            recoverPasswordControl.errors?.['invalid']) {
            <mat-error>E-mail inválido.</mat-error>
            }
          </div>
        </div>

        <button
          mat-flat-button
          class="w-full submit-button"
          [disabled]="recoverPasswordControl.invalid"
          (click)=" loading ? null : recoverPassword()"
        >
          @if(loading) {
          <mat-spinner class="loading-spinner" diameter="40" color="#FFF">
          </mat-spinner>
          } @else { Recuperar senha }
        </button>
      </form>
    </div>

    <div class="w-full h-full" [ngClass]="windowSize < 1024 ? 'hidden' : ''">
      <img
        src="assets/images/recover-password-page-image.png"
        alt="Vôlei"
        class="h-19/20 w-full rounded-lg object-cover"
      />
    </div>
  </div>
</div>
